<template>
    <Page :total="total" show-elevator class="pager" @on-change="onChange"/>
</template>

<script>
export default {
  name: 'Pager',
  props: {
    total: [String, Number]
    // onChange: [Function]
  },
  model: {
    event: 'change'
  },
  methods: {
    onChange (page) {
      this.$emit('on-page-change', page)
    }
  }
}
</script>

<style lang="less">
.pager {
    margin: 10px 0;
}
</style>
